import React from "react";
import assign from "lodash/assign";
import { useTranslation } from "react-i18next";
import { Select } from "../Form";
import { useLocation, useHistory } from "react-router";
import querystring from 'querystring';
import pickBy from "lodash/pickBy";
var Component = function (_a) {
    var _b = _a.onUpdate, onUpdate = _b === void 0 ? function () { } : _b, filterPrefix = _a.filterPrefix, prop = _a.prop, options = _a.options;
    var history = useHistory();
    var t = useTranslation().t;
    var search = useLocation().search;
    var currentFilters = querystring.parse(search.substr(1));
    var name = prop;
    if (!name)
        return null;
    name = currentFilters[name] ? name : filterPrefix + name;
    var currentFilter = currentFilters[name];
    var onChange = function (value) {
        var _a;
        var newFilter = (_a = {}, _a[name] = value, _a);
        var search = decodeURIComponent(querystring.stringify(pickBy(assign(currentFilters, newFilter), function (x) { return !!x; })));
        onUpdate();
        history.push({ search: search });
    };
    var placeholder = t("course_filters." + prop);
    return React.createElement(Select, { hideOnNoOptions: false, onChange: onChange, value: currentFilter, placeholder: placeholder, name: prop, options: options });
};
export var CourseFilterDropdown = Component;
